import { render, staticRenderFns } from "./SolicitacaoAutorizLog.vue?vue&type=template&id=5c5a3c78&"
import script from "./SolicitacaoAutorizLog.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoAutorizLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports